import React from "react";
import { Brain } from "lucide-react";

const LoadingIndicator: React.FC = () => {
  return (
    <div className="flex items-start gap-3 mb-6">
      {/* Assistant Avatar */}
      <div className="flex-shrink-0">
        <div className="w-8 h-8 rounded-full bg-accent text-white flex items-center justify-center">
          <Brain className="w-5 h-5" />
        </div>
      </div>

      {/* Loading Animation */}
      <div className="flex-1">
        <div className="bg-surface border border-subtle rounded-lg p-4 max-w-3xl">
          <div className="flex items-center gap-2">
            <div className="flex gap-1">
              <div
                className="w-2 h-2 bg-accent rounded-full animate-bounce"
                style={{ animationDelay: "0ms" }}
              ></div>
              <div
                className="w-2 h-2 bg-accent rounded-full animate-bounce"
                style={{ animationDelay: "150ms" }}
              ></div>
              <div
                className="w-2 h-2 bg-accent rounded-full animate-bounce"
                style={{ animationDelay: "300ms" }}
              ></div>
            </div>
            <span className="text-sm text-text-faint">Thinking...</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingIndicator;
